import {
  DefaultTitle, 
  DefaultSubtitle,
  ApplicationBodyContainer,
  ApplicationBodyContent
} from 'src/components/application/defaultComponents'
import PrebuiltRenewalFooter from 'src/components/application/PrebuiltRenewalFooter'
import { useRenewal } from 'src/context/renewal'
import { useToast } from 'src/hooks/useToast'

const Verify = () => {
  const { renewalData } = useRenewal()
  const { callToast } = useToast()
  const nextRoute = () => {
    if(renewalData?.insuranceType === 'LAWYER') {
      return '/customer/renew/firm/main'
    }
    else if(renewalData?.insuranceType === 'JUDGE')
    {
      return '/customer/renew/judge/basic/main'
    }
    else{
      callToast({
            header: 'Unexpected Error',
            footer: "unable to determine insurance type, please contact admin",
            type: 'error'
        })

        return ''
    }
  }
  
  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Next, let’s verify some basic information{renewalData?.insuranceType === 'LAWYER' ? ' about your firm.' : '.'}</DefaultTitle>
        <DefaultSubtitle>
          The following pages are pre-filled based on your previous application. Please check that all information is still correct and update anything that has changed since your last application.
        </DefaultSubtitle>
      </ApplicationBodyContent>
      <PrebuiltRenewalFooter
        goBackRoute='/customer/renew/type'
        nextRoute={nextRoute()}
        updatedApplication={renewalData}
      />
    </ApplicationBodyContainer>
  )
}

export default Verify